import useAppConfig from '@rhg/hooks/use-app-config';
import {
    AmplitudeExperimentContext,
    ExperimentContext,
} from '@rhg/providers/experiment-client';
import { useContext, useEffect, useMemo } from 'react';

export type ExperimentContextValue = Omit<
    AmplitudeExperimentContext,
    'isExperimentUserReady'
> & {
    isExperimentUserReady: boolean;
};

export function useExperimentContext(): ExperimentContextValue {
    const context = useContext(ExperimentContext);
    const { NEXT_PUBLIC_ENV } = useAppConfig();
    const isSyncProviderMissing = context.isExperimentUserReady === null;

    useEffect(() => {
        if (NEXT_PUBLIC_ENV !== 'production' && isSyncProviderMissing) {
            console.warn(
                'useExperimentContext was called without ExperimentUserSyncProvider in the tree — flag evaluations will be silently blocked. Wrap the consumer subtree in <ExperimentUserSyncProvider> (must mount below auth / active-circle / query-client providers).'
            );
        }
    }, [isSyncProviderMissing, NEXT_PUBLIC_ENV]);

    return useMemo(
        () => ({
            ...context,
            isExperimentUserReady: context.isExperimentUserReady ?? false,
        }),
        [context]
    );
}
